import { Logo } from "./Logo";
import copy from "@/content/homepage-copy.json";

const COLUMNS = [
  { title: "Produkt", links: ["Pakiety", "Jak to działa", "Efekty", "Cennik"] },
  { title: "Konto", links: ["Zaloguj się", "Moje zakupy", "Moje pakiety"] },
  { title: "Pomoc", links: ["FAQ", "Kontakt", "Instrukcje"] },
  { title: "Prawo", links: ["Regulamin", "Polityka prywatności", "Licencja", "Polityka cookies"] },
];

export const Footer = () => {
  return (
    <footer id="konto" className="border-t border-brand-line bg-brand-bg" data-testid="site-footer">
      <div className="mx-auto max-w-content px-4 py-16 md:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-6">
          <div className="col-span-2">
            <Logo height={28} />
            <p className="mt-4 max-w-xs text-sm text-brand-sec">{copy.brand.tagline}</p>
            <p className="mt-3 max-w-xs text-sm text-brand-muted">{copy.legal.updatesShort}</p>
          </div>
          {COLUMNS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="font-display text-sm font-semibold text-brand-text">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-brand-sec transition-colors duration-200 hover:text-brand-accent"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-brand-line pt-8 text-xs text-brand-muted sm:flex-row sm:items-center sm:justify-between">
          {/* Pełne dane podmiotu sprzedającego zostaną dodane po zatwierdzeniu. */}
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span>© 2026 {copy.brand.name}. Dane sprzedawcy zostaną uzupełnione po zatwierdzeniu.</span>
            <button
              type="button"
              data-testid="footer-cookie-settings"
              onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
              className="text-brand-sec underline-offset-2 transition-colors duration-200 hover:text-brand-accent hover:underline"
            >
              Ustawienia cookies
            </button>
            <button
              type="button"
              data-testid="footer-feedback"
              onClick={() => window.dispatchEvent(new Event("open-feedback"))}
              className="text-brand-sec underline-offset-2 transition-colors duration-200 hover:text-brand-accent hover:underline"
            >
              Zgłoś problem lub uwagę
            </button>
          </div>
          <p className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
            <span>{copy.brand.domain}</span>
            <span aria-hidden>·</span>
            <span>
              Pomysł i realizacja:{" "}
              <a
                href="https://apisdesign.pl"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-credit-apisdesign"
                className="text-brand-sec transition-colors duration-200 hover:text-brand-accent"
              >
                apisdesign.pl
              </a>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};
